import { useUser } from "@/composables/user";
import { isPublic, redirectToAuth } from "@/router/helpers";
import { checkUserOnInitialPageLoad } from "@/services/user/auth/login";
import { type NavigationGuardNext, type RouteLocationNormalized } from "vue-router";

export const handleLogin = async (route: RouteLocationNormalized, _: RouteLocationNormalized, next: NavigationGuardNext) => {
  await checkUserOnInitialPageLoad();
  const { isUserLoggedIn } = useUser();
  const requireLogin = !isUserLoggedIn.value && !isPublic(route);

  if (requireLogin) {
    return redirectToAuth(route, next);
  } else {
    return next();
  }
};
